import { render, staticRenderFns } from "./CreatePermissions.vue?vue&type=template&id=21fb7752&"
import script from "./CreatePermissions.vue?vue&type=script&lang=js&"
export * from "./CreatePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports